import React, { Component } from "react";
import { Link } from "dva/router";
import {
    Button,
    WhiteSpace,
    WingBlank,
    InputItem,
    Flex,
    Toast,
    Picker,
    Checkbox,
} from "antd-mobile";
import company_logo from "../../assets/images/admin_logo.png";
import "./login.scss";
import axios from "../../service/axios";
const AgreeItem = Checkbox.AgreeItem;


const userTypeList = [
    {
        label: <div key="1">管理员登录</div>,
        value: 0,
    },
    {
        label: <div key="2">子调度登录</div>,
        value: 5,
    }
];
const userLoginType = [
    {
        label: <div key='1'>中文</div>,
        value: 'zh'
    },
    {
        label: <div key='2'>English</div>,
        value: 'en'
    }
]

export class Login extends Component {
    state = {
        loading: false,
        username: "",
        password: "",
        userType: 0,
        userTypeName: '管理员登录',
        isRemember: false
    };
    componentDidMount(){
        console.log('初始化~',rememberedUsername,rememberedPassword)
        const rememberedUsername = localStorage.getItem('rememberedUsername');
        const rememberedPassword = localStorage.getItem('rememberedPassword');
        console.log('初始化~',rememberedUsername,rememberedPassword)
        if(rememberedUsername&&rememberedPassword){
            this.setState({
                username: rememberedUsername,
                password: rememberedPassword,
                isRemember: true
            })
        }
    }

    onChangeUserName = value => {
        this.setState({
            username: value,
        });
    };
    onChangePassword = value => {
        this.setState({
            password: value,
        });
    };
    onChangeUserType = value => {
        console.log('userType', value[0])
        let name = value[0] == 5 ? '子调度登录' : '管理员登录'
        this.setState({
            userType: value[0],
            userTypeName: name
        });
    }
    onChangeUserLoginType = value => {
        console.log('userLoginType', value[0])
    }

    validateInfo = () => {
        return new Promise(rev => { });
    };
    onLoginBtn = () => {
        const { username, password, userType } = this.state;
        if (!username) {
            Toast.info("请填写用户名！", 2);
            return;
        }
        if (!password) {
            Toast.info("请填写密码！", 2);
            return;
        }
        this.setState({
            loading: true,
        });
        // let data = (username + password).split('').reverse().join('')
        // console.log('data?', data)
        // let md5Data = md5(data)
        // console.log('md5Data?', md5Data)
        console.log('can~',this.state)
        if(this.state.isRemember){
            localStorage.setItem('rememberedUsername', this.state.username);
            localStorage.setItem('rememberedPassword', this.state.password);
        } else {
            localStorage.removeItem('rememberedUsername');
            localStorage.removeItem('rememberedPassword');
        }
        axios
            .post("/auth/open/login", {
                loginName: username,
                password: password,
                userType: userType
            })
            .then(res => {
                //获取
                console.log(res, 33333);
                this.setState({
                    loading: false,
                });
                if (res.data && res.status == 200) {
                    sessionStorage.setItem(
                        "loginMsg",
                        JSON.stringify(res.data.loginUser),
                    );
                    sessionStorage.setItem(
                        "manager-web-session",
                        res.data["manager-web-session"],
                    );
                    sessionStorage.setItem(
                        "pc-access-token",
                        res.data["token"],
                    );
                    this.getYears(res.data.loginUser);
                } else {
                    Toast.info(res.message, 2);
                }
            })
            .catch(res => {
                this.setState({
                    loading: false,
                });
            });
    };
    async getYears (loginUser) {
        let preferentialMonths = 0;
        let userValidYears = 0;
        let permissionCodeList = [];
        //获取设置优惠年限
        await axios
            .get("/api/user/admin/preferentialMonths/get", {})
            .then(res => {
                if (res.status == 200 && res.data) {
                    preferentialMonths = res.data;
                }
            })
        //获取账号有效年限
        await axios
            .get("/api/user/admin/validYears/get", {})
            .then(res => {
                if (res.status == 200 && res.data) {
                    userValidYears = res.data;
                }
            })
        //获取管理员权限
        await axios
            .get("/api/admin/permission/find/adminId", {
                params: {
                    adminId: loginUser.id,
                }
            })
            .then(res => {
                if (res.status == 200 && res.data) {
                    permissionCodeList = res.data.map(item => item.code);
                }
            })
        sessionStorage.setItem(
            "loginMsg",
            JSON.stringify({ ...loginUser, preferentialMonths, userValidYears, permissionCodeList }),
        )
        Toast.info("登录成功", 2);
        window.location.reload();
    }
    render () {
        return (
            <div className="login">
                <WingBlank>
                    <div className="login-top">
                        <Flex justify="center">
                            <img src={company_logo} alt="" />
                        </Flex>
                        <Flex justify="center">
                            <h2>公网对讲调度管理平台</h2>
                        </Flex>
                    </div>
                    <div className="middle">
                        <div className=" middle-info">
                            <InputItem
                                value={this.state.username}
                                onChange={this.onChangeUserName}
                                clear
                                placeholder="用户名"
                            />
                        </div>
                        <div className=" middle-info">
                            <InputItem
                                value={this.state.password}
                                onChange={this.onChangePassword}
                                clear
                                type="password"
                                placeholder="密码"
                            />
                        </div>
                    </div>
                    <span>
                    <Flex>
                        <Flex.Item>
                            <AgreeItem  checked={this.state.isRemember} onChange={e => this.setState({isRemember:e.target.checked})}>
                                <span style={{fontSize:'12px',paddingLeft:'10px'}}>记住账号</span>
                            </AgreeItem>
                        </Flex.Item>
                    </Flex>   
                    </span>
                    <div className="bottom">
                        <Button
                            loading={this.state.loading}
                            disabled={this.state.loading}
                            type="primary"
                            onClick={this.onLoginBtn}
                        >
                            登录
                        </Button>
                    </div>
                    <div className="register">
                        <Picker
                            data={userTypeList}
                            cols={1}
                            onChange={this.onChangeUserType}
                            onOk={this.onChangeUserType1}

                        >
                            <Button>登录方式：{this.state.userTypeName}</Button>
                        </Picker>
                        {/* <Button href="/register">注册</Button> */}
                        {/* <Picker
                            data={userLoginType}
                            cols={1}
                            onChange={this.onChangeUserLoginType}
                            onOk={this.onChangeUserLoginType}
                        >
                            <Button></Button>
                        </Picker> */}
                    </div>
                    <WhiteSpace />
                </WingBlank>
            </div>
        );
    }
}

export default Login;
